module.exports = __webpack_public_path__ + "static/img/bg_title@2x.ea822e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/KtbPopularize/bg_title@2x.png
// module id = BdrX
// module chunks = 70